export type OptionType = {
  label: string;
  [key: string]: string | boolean;
};

export type FieldsOptions = {
  [key: string]: OptionType[];
};

const FIELD_OPTIONS: FieldsOptions = {
  countryCodeOptions: [
    { label: 'United States (+1)', value: 'US', code: '+1' },
    { label: 'Canada (+1)', value: 'CA', code: '+1' },
  ],
  numberTypeOptions: [
    { label: 'Local', value: 'LOCAL' },
    { label: 'Toll-free', value: 'TOLL_FREE' },
  ],
  filterTypeOptions: [
    { label: 'Area code', value: 'AREA_CODE' },
    { label: 'City', value: 'LOCALITY' },
    { label: 'Contains', value: 'CONTAINS' },
  ],
  capabilities: [
    { checked: false, label: 'Voice' },
    { checked: false, label: 'SMS' },
    { checked: false, label: 'MMS' },
  ],
};

export default FIELD_OPTIONS;
